import type { UseMutationResult } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";

import { useContactsFlowStrategy } from "../../context/ContactsFlowContext";
import { toUniqueContactId } from "../../helpers/common";
import type { ContactSearchEntry, ContactsSearchResults } from "../../types/common";

import type { IRevealedContactResponse } from "./useSingleRevealContactInfoQuery";
import useSingleRevealContactInfoQuery from "./useSingleRevealContactInfoQuery";

const useSingleRevealContactWithUpdateQuery = (): UseMutationResult<IRevealedContactResponse> => {
    const queryClient = useQueryClient();
    const strategy = useContactsFlowStrategy();

    return useSingleRevealContactInfoQuery((data: IRevealedContactResponse, contactEntry: ContactSearchEntry) => {
        const uniqueEntryId = toUniqueContactId(contactEntry);

        queryClient.setQueryData(strategy.getRevealCacheKey(), (oldData: ContactsSearchResults) => ({
            ...oldData,
            rows: oldData?.rows?.map((item: ContactSearchEntry) =>
                toUniqueContactId(item) === uniqueEntryId
                    ? { ...item, isRevealed: true, privateData: data.revealedInfo }
                    : item,
            ),
        }));
    });
};

export default useSingleRevealContactWithUpdateQuery;
